/**
 * BFS / Polaris page width SSOT.
 *
 * @see https://shopify.dev/docs/apps/design/layout
 * @see https://shopify.dev/docs/apps/launch/built-for-shopify/requirements
 * @see SafeGeo_UI_UX_Final_v1.4 §F (Polaris)
 *
 * Rules:
 * - `base` (default) - Home, Plans, and most screens; required for aside / visual-editor 2-col.
 * - `large` - reserved; do not use for Plans (same width as Home).
 * - Never put a two-column editor on `large` (BFS: harder to parse on wide displays).
 * - Never use `large` for a single-column settings/help/home page.
 */

export type PageInlineSize = "small" | "base" | "large";

export type SafeScreen =
  | "home"
  | "plans"
  | "countries"
  | "markets"
  | "redirects"
  | "block"
  | "rule-form"
  | "popup"
  | "settings"
  | "stores"
  | "help"
  | "welcome"
  | "setup";

/** Canonical width per screen. */
export const PAGE_SIZE: Record<SafeScreen, PageInlineSize> = {
  home: "base",
  plans: "base",
  countries: "base",
  markets: "base",
  redirects: "base",
  block: "base",
  "rule-form": "base",
  popup: "base",
  /** Same width as Home / Markets - not Shopify’s narrow settings template. */
  settings: "base",
  stores: "base",
  help: "base",
  welcome: "base",
  setup: "base",
};

export function pageSizeFor(screen: SafeScreen): PageInlineSize {
  return PAGE_SIZE[screen];
}
